import HorizontalRule from '@tiptap/extension-horizontal-rule';

export default HorizontalRule.configure({
  HTMLAttributes: {
    class: 'dashdraft-hr',
  },
});
